/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PlaceOpening } from './PlaceOpening';
export type ConfigurationPreconditionPayload = {
    name: string;
    therapistType: ConfigurationPreconditionPayload.therapistType;
    streetAndNumber: string;
    additionalInformation?: string;
    cityName: string;
    zip: string;
    openings?: Array<PlaceOpening>;
    type: ConfigurationPreconditionPayload.type;
};
export namespace ConfigurationPreconditionPayload {
    export enum therapistType {
        THERAPIST = 'therapist',
        CONSULTANT = 'consultant',
        COACH = 'coach',
        OTHER = 'other',
    }
    export enum type {
        SELECT_PLAN = 'select-plan',
        CONFIGURATION = 'configuration',
        BILLING = 'billing',
        OPENINGS = 'openings',
        WAITLIST = 'waitlist',
        ONBOARDING_GENERAL = 'onboarding-general',
        ONBOARDING_FIRST_CATEGORY = 'onboarding-first-category',
        ONBOARDING_AVAILABILITY = 'onboarding-availability',
        ONBOARDING_DISTRIBUTION = 'onboarding-distribution',
        ONBOARDING_FINISHED = 'onboarding-finished',
        ONBOARDING_PROFILE = 'onboarding-profile',
        ONBOARDING_FIRST_EVENTS = 'onboarding-first-events',
        ONBOARDING_BOOKING_SITES = 'onboarding-booking-sites',
        ONBOARDING_WIDGET = 'onboarding-widget',
    }
}

